export default class ComplianceAuditLog {
  constructor(public requestNbr: number,
    public event: string,
    public page: string,
    public description: string,
    public comment:  string) {}
}



// WEBPACK FOOTER //
// ./src/models/complianceAuditLog.ts